export default __webpack_public_path__ + "static/media/chrome.8c8a97f2.png";